import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Segmented control for switching agent operating modes.
 * Only renders if the agent reports available modes.
 */
export function ModeSelector({ modes, currentMode, onSelectMode }) {
    if (!modes || modes.length === 0)
        return null;
    return (_jsxs("div", { className: "flex items-center space-x-1", children: [_jsx("span", { className: "text-xs text-gray-500 mr-1", children: "Mode:" }), _jsx("div", { className: "flex rounded-md border border-gray-300 overflow-hidden", children: modes.map((mode) => (_jsx("button", { onClick: () => onSelectMode(mode), "aria-pressed": mode === currentMode, className: `px-2.5 py-1 text-xs font-medium capitalize transition-colors ${mode === currentMode
                        ? 'bg-blue-600 text-white'
                        : 'bg-white text-gray-600 hover:bg-gray-50'}`, children: mode }, mode))) })] }));
}
//# sourceMappingURL=ModeSelector.js.map